import { isBlockerCategory } from '@/features/audit-issues';

/**
 * Filtered destination for the FULL set behind a category (spec-13 §8.3 /
 * round-6 item 7): exception categories open the exception list with its
 * severity/status filters; every other category opens the monthly-batch
 * list in blocker mode, which fetches the scoped per-category batch list
 * (`GET /dashboard/blockers/:category/batches`) — never an unfiltered list.
 * Unknown categories fall back to the plain batch list.
 */
export const listPathForCategory = (category: string): string => {
  if (category === 'open_critical_exceptions') return '/exceptions?severity=critical&status=open';
  if (category === 'open_error_exceptions') return '/exceptions?severity=error&status=open';
  if (isBlockerCategory(category)) return `/batches?blocker=${encodeURIComponent(category)}`;
  return '/batches';
};
